import React from 'react';

import { Inline, Stack } from '@atlaskit/primitives/compiled';
import { AgentActionPill } from '@atlassian/conversation-assistant-agent/ui/AgentActionPill';

export type Action = {
	actionKey: string;
	icon?: React.ReactNode;
	iconUrl?: string;
	isActive: boolean;
	name: string;
	tags?: string[];
};

type ActionPillListProps = { actions: Action[] };

export const SkillList = ({ actions }: ActionPillListProps): React.JSX.Element => {
	return (
		<Stack space="space.050">
			{actions.map((action) => (
				<Inline space="space.100" key={`skill-pill-${action.actionKey}`} alignBlock="center">
					<AgentActionPill
						action={{
							id: action.actionKey,
							displayName: action.name,
							icon: action.icon,
							tags: action.tags,
							iconUrl: action.iconUrl,
						}}
						isActive={action.isActive}
					/>
				</Inline>
			))}
		</Stack>
	);
};
